export enum AiChatLandingTipType {
  FIRST_MESSAGE_DETAILS = 'landing_first_message_details',
  SHORT_TEXT = 'landing_short_text',
  MENTION_STYLE = 'landing_mention_style',
  ATTACH_INSPIRATION = 'landing_attach_inspiration',
  EXACT_TEXT_QUOTES = 'landing_exact_text_quotes',
  DESCRIBE_EDIT_ITEM = 'landing_describe_edit_item',
  SPECIFY_ATTACHMENT_ACTION = 'landing_specify_attachment_action',
  TEXT_CHANGES_QUOTES = 'landing_text_changes_quotes',
  SPECIFY_OBJECT_LOCATION = 'landing_specify_object_location',
  REFER_OBJECTS_IN_ATTACHMENTS = 'landing_refer_objects_in_attachments',
  DESCRIBE_EXACT_CHANGES = 'landing_describe_exact_changes',
}
